import * as S from './row-desktop.styled'
import React, { HTMLAttributes } from 'react'
import { SkeletonPlaceholder } from 'src/shared/ui/skeleton/skeleton.styled'

interface RowDesktopProps extends HTMLAttributes<HTMLInputElement> {
    dataId?: string | number
    title: string
    description?: string
}

export function RowDesktopSkeleton() {
    return (
        <S.Container>
            <S.SkeletonTitle>
                <SkeletonPlaceholder />
            </S.SkeletonTitle>
            <S.SkeletonDescription>
                <SkeletonPlaceholder />
            </S.SkeletonDescription>
        </S.Container>
    )
}

export function RowDesktop({ title, description, dataId, ...props }: RowDesktopProps) {
    return (
        <S.Container data-set-id={dataId} data-row-id={dataId} {...props}>
            <S.Title>{title}</S.Title>
            {description && (
                <S.DescriptionBlock>
                    <S.Description>{description}</S.Description>
                </S.DescriptionBlock>
            )}
        </S.Container>
    )
}
